/* eslint-disable import/prefer-default-export */
import { tw } from "~/common/concat";

export const baseTileButtonStyling = tw(
  "bg-transparent",
  "box-border",
  "p-2",
  "border-0",
  "cursor-pointer",
  "relative",
  "before:rounded",
  "before:content-['']",
  "before:absolute",
  "before:inset-0"
);

export const selectedTileButtonBorderStyling = tw(
  "before:border-2",
  "before:border-blue-400"
);

export const baseBorderStyling = tw("before:border", "before:border-gray-600");

export const baseHoverStyling = tw(
  "[@media(hover:hover)]:hover:before:border-2",
  "[@media(hover:hover)]:hover:before:border-gray-700",
  "focus:outline",
  "focus:outline-3",
  "focus:outline-offset-[-3px]",
  "focus:outline-transparent"
);
